<!-- @format -->

<template>
  <div id="create-post-dialog" class="custom-modal">
    <div class="modal-body">
      <transition name="el-fade-in" mode="out-in">
        <HolaconLottie v-if="loading == 'updateScreenLoading' && form == null" key="create-loading" />
        <el-row v-else key="content-loading">
          <el-row>
            <el-col :span="24" class="post-type-select">
              <div class="item" :class="{ active: form.type == 0 }" @click="form.type = 0">
                <div class="icon">
                  <i class="fa fa-paper-plane"></i>
                </div>
                <div class="item-content">
                  <div class="head">{{ $t("components.socialhub.createPost.post") }}</div>
                  <div class="sub">{{ $t("components.socialhub.createPost.createsContent") }}</div>
                </div>
              </div>
              <div class="item " :class="{ active: form.type == 1 }" @click="true ? (form.type = 1) : (form.type = 0)">
                <upgrade-overlay position="absolute" :onlyButton="true" v-if="false" :buttonText="$t('components.socialhub.createPost.vote')" size="mini"></upgrade-overlay>
                <div class="icon">
                  <i class="fa fa-hand-pointer"></i>
                </div>
                <div class="item-content">
                  <div class="head">{{ $t("components.socialhub.createPost.vote") }}</div>
                  <div class="sub">{{ $t("components.socialhub.createPost.createVote") }}</div>
                </div>
              </div>
              <div class="item " :class="{ active: form.type == 2 }" @click="true ? (form.type = 2) : (form.type = 0)">
                <upgrade-overlay position="absolute" :onlyButton="true" :buttonText="$t('components.socialhub.createPost.survey')" v-if="false" size="mini"></upgrade-overlay>
                <div class="icon">
                  <i class="fa fa-tasks"></i>
                </div>
                <div class="item-content">
                  <div class="head">{{ $t("components.socialhub.createPost.survey") }}</div>
                  <div class="sub">{{ $t("components.socialhub.createPost.createSurvey") }}</div>
                </div>
              </div>
            </el-col>
          </el-row>

          <el-row class="mt-3" :gutter="10">
            <el-col :span="12">
              <div class="registerform-input-container">
                <div class="title">
                  <div>
                    <label>{{ $t("components.socialhub.createPost.subject") }}</label>
                    <el-tooltip placement="top">
                      <div slot="content" class="custom-tooltip-content">
                        <span>{{ $t("components.socialhub.createPost.defineSubjectContent") }}</span>
                      </div>
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                </div>
                <el-select v-model="form.topic" :placeholder="$t('components.socialhub.createPost.placeholderSelect')" clearable @clear="form.topic = null" value-key="id">
                  <el-option v-for="item in socialHub.topics.filter(x => x.isActive == true && x.title != null && x.title != '')" :key="item.id" :label="item.title" :value="item">
                    <template>
                      <i class="fas fa-square" :style="'color:' + item.color"></i>
                      <span>{{ item.title }}</span>
                    </template>
                  </el-option>
                </el-select>
                <span class="error">{{ $errorMessage("topic", validationErrors) }}</span>
              </div>
            </el-col>

            <el-col :span="12">
              <div class="registerform-input-container">
                <div class="title">
                  <div>
                    <label>{{ $t("components.socialhub.createPost.liveSession") }}</label>
                    <el-tooltip placement="top">
                      <div slot="content" class="custom-tooltip-content">
                        <span>{{ $t("components.socialhub.createPost.allowsPost") }}</span>
                      </div>
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                </div>
                <el-select v-model="form.session" :placeholder="$t('components.socialhub.createPost.placeholderSelect')" clearable @clear="form.session = null" value-key="id">
                  <el-option v-for="item in $store.state.livesessions.items" :key="item.id + '-livesession-item'" :label="item.title" :value="item"></el-option>
                </el-select>
                <span class="error">{{ $errorMessage("session", validationErrors) }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row class="mt-3" :gutter="10">
            <el-col :span="12">
              <div class="registerform-input-container">
                <div class="title">
                  <div>
                    <label>{{ $t("components.socialhub.createPost.sendNotification") }}</label>
                    <el-tooltip placement="top">
                      <div slot="content" class="custom-tooltip-content">
                        <span>{{ $t("components.socialhub.createPost.contentNotification") }}</span>
                      </div>
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                </div>
                <div class="controller-item" :class="form.sendAnnouncementNotification ? '' : 'isPassive'">
                  <span><i class="fa fa-bell"></i></span>
                  <el-switch v-model="form.sendAnnouncementNotification"></el-switch>
                </div>
                <span class="error">{{ $errorMessage("isAnnouncement", validationErrors) }}</span>
              </div>
            </el-col>

            <el-col :span="12">
              <div class="registerform-input-container">
                <div class="title">
                  <div>
                    <label>{{ $t("components.socialhub.createPost.draft") }}</label>
                    <el-tooltip placement="top">
                      <div slot="content" class="custom-tooltip-content">
                        <span>{{ $t("components.socialhub.createPost.savePost") }}</span>
                      </div>
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                </div>
                <div class="controller-item" :class="form.isDraft ? '' : 'isPassive'">
                  <span><i class="fa fa-pen"></i></span>
                  <el-switch v-model="form.isDraft"></el-switch>
                </div>
                <span class="error">{{ $errorMessage("isDraft", validationErrors) }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row class="mt-3" :gutter="10" v-if="form.type == 2">
            <el-col :span="24">
              <div class="registerform-input-container">
                <div class="title">
                  <div>
                    <label>{{ $t("components.socialhub.createPost.title") }}</label>
                    <el-tooltip placement="top">
                      <div slot="content" class="custom-tooltip-content">
                        <span>{{ $t("components.socialhub.createPost.defineTitle") }}</span>
                      </div>
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                </div>
                <el-input v-model="form.title"></el-input>
                <span class="error">{{ $errorMessage("title", validationErrors) }}</span>
              </div>
            </el-col>
          </el-row>
          <input type="file" @change="uploadFile" style="display: none" ref="file" />

          <el-row class="mt-3" :gutter="10" v-if="form.type == 1 || form.type == 2">
            <el-col :span="24">
              <QuestionLibrary :id="id" v-if="form.type == 1" :type="7" :key="'social-pool-question'" />
              <QuestionLibrary :id="id" v-if="form.type == 2" :type="2" :key="'social-survey-question'" />
            </el-col>
          </el-row>
        </el-row>
      </transition>
    </div>
    <div class="modal-footer" slot="footer" v-if="loading != 'updateScreenLoading' && form != null">
      <div class="send-post-section">
        <div class="write-post-container">
          <div class="write-post-textarea">
            <div class="mention-area" v-dragscroll.x v-if="mentionEnable">
              <div class="mention-item" v-for="item in mentionableUser" :key="item.id" @click="tagUser(item)">
                <img :src="item.image" />
                <span>{{ item.fullName }}</span>
              </div>
            </div>

            <div class="write-area">
              <el-tooltip placement="top" :content="$t('components.socialhub.createPost.picMsg')">
                <div class="add-image-post cursor-pointer" @click="select" v-loading="loading == 'uploading'" :style="{ backgroundImage: form.image != null ? 'url(' + form.image + ')' : 'url(' + placeholderImage + ')' }">
                  <i class="el-icon-picture" aria-hidden="true" v-if="!loading && form.image == null"></i>
                  <i class="fa fa-trash" style="color: #ff6565;" aria-hidden="true" v-if="form.image != null"></i>
                </div>
              </el-tooltip>

              <el-input type="textarea" :rows="1" placeholder="..." resize="none" v-model="form.postText"></el-input> {{ uploading }}
              <el-button size="mini" type="primary" class="post-send-button" @click="savePost" round>
                <i class="fa send-icon" v-if="loading == false" :class="form.isDraft ? 'fa-pen' : 'fa-paper-plane'" aria-hidden="true"></i>
                <i class="fa fa-spinner fa-spin" v-else aria-hidden="true"></i>
                {{ form.isDraft ? $t("components.socialhub.createPost.save") : $t("components.socialhub.createPost.share") }}
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import QuestionLibrary from "../register-form/QuestionLibrary.vue";
// Types
// 1 = Post
// 2 = Topic post - iptal
// 3 = Poll
// 4 = Survey
import { dragscroll } from "vue-dragscroll";
import VueGallery from "vue-gallery";

export default {
  props: ["id"],
  name: "CreatePost",
  directives: {
    dragscroll
  },
  components: { gallery: VueGallery, QuestionLibrary },
  data() {
    return {
      placeholderImage: "https://via.placeholder.com/200x200",
      axios,
      sessionId: null,
      currentQuestions: [],
      loading: false,
      timeout: null,
      mentionableUser: [],
      mentionEnable: false,
      previewMode: false,
      surveyOpened: false,
      contentDock: false,
      form: {
        id: null,
        postText: null,
        title: null,
        image: null,
        topic: null,
        session: null,
        isDraft: true,
        isAnnouncement: true,
        sendAnnouncementNotification: false,
        type: 0,
        mentions: [
          // {
          //   id: null,
          //   type: 0,
          //   color: null,
          //   title: null,
          //   image: null,
          //   fullName: null
          // }
        ]
      },
      searchTerm: null,
      post: {
        isAnnouncement: true,
        isDraft: false,
        commentCount: 3,
        isLiked: false,
        type: 1,
        topic: {
          title: "Muhammete sor"
        }
      },
      options: [
        {
          value: "Option1",
          label: "Option1"
        },
        {
          value: "Option2",
          label: "Option2"
        },
        {
          value: "Option3",
          label: "Option3"
        },
        {
          value: "Option4",
          label: "Option4"
        },
        {
          value: "Option5",
          label: "Option5"
        }
      ],
      value: "",
      validationErrors: []
    };
  },
  computed: {
    eventPermissions() {
      return this.$store.getters.getEventPermission;
    },
    socialHub() {
      return this.$store.state.event.event.socialHub;
    }
  },
  methods: {
    async uploadFile() {
      let file = this.$refs.file.files[0];
      var fd = new FormData();
      this.loading = "uploading";
      fd.append("file", file);
      var res = await axios.post("event/uploadImage?uploadType=message", fd, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
      if (res.data.alert.hasError) {
        this.$message.error(res.data.alert.message);
        this.$refs.file.value = null;
      } else {
        this.form.image = res.data.data.item.url;
      }
      this.$refs.file.value = null;
      this.loading = false;
    },
    select() {
      if (this.form.image != null) {
        this.form.image = null;
      } else {
        this.$refs.file.click();
      }
    },
    parseUrl(text, post) {
      if (text == null) {
        return "";
      }
      var urlRegex = /(https?:\/\/[^\s]+)/g;
      var usernameRegex = /\%(.*?)\%/g;
      var standName = /\#(.*?)\#/g;
      text = text.replace(urlRegex, function(url) {
        return url;
      });

      text = text.replace(usernameRegex, function(url) {
        var user = null;

        if (post.mentions != null && post.mentions.some(k => k.id == url.replace("%", "").replace("%", ""))) {
          var user = post.mentions.find(k => k.id == url.replace("%", "").replace("%", ""));
          return "@" + user.fullName;
        } else {
          return url;
        }
      });

      text = text.replace(standName, function(url) {
        var user = null;

        if (post.taggedStands != null && post.taggedStands.some(k => k.id == url.replace("#", "").replace("#", ""))) {
          var user = post.taggedStands.find(k => k.id == url.replace("#", "").replace("#", ""));
          return '<a href="javascript:;" user-id="' + url.replace("#", "").replace("#", "") + '" class="open-url">' + user.title + "</a>";
        } else {
          return url;
        }
      });

      return text;
    },
    tagUser(user) {
      this.form.mentions.push(user);
      this.form.postText = this.form.postText.replace("@" + this.searchTerm, "@" + user.fullName);
      this.mentionEnable = false;
      this.searchTerm = null;
      this.mentionableUser = [];
    },
    async savePost() {
      this.loading = "saveLoading";
      if (!this.form.isAnnouncement) {
        this.form.sendAnnouncementNotification = false;
      }
      if (this.form.isAnnouncement && this.form.sendAnnouncementNotification && this.form.isDraft) {
        this.$message.info(this.$t('components.socialhub.createPost.announcementError'));
        this.loading = false;
        return;
      }
      var postText = this.form.postText;
      this.form.mentions.forEach(user => {
        if (postText.includes("@" + user.fullName)) {
          postText = postText.replace("@" + user.fullName, "%" + user.id + "%");
        } else {
          var fIndex = this.form.mentions.findIndex(x => x.id == user.id);
          if (fIndex != -1) {
            this.form.mentions.splice(fIndex, 1);
          }
        }
      });
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("socialHubAddOrUpdate", { ...this.form, postText: postText });
        this.validationErrors = res.data.validationErrors;
        if (!res.data.alert.hasError) {
          this.$emit("closeDialog");
        }
        this.loading = false;
      }, 500);
    }
  },
  watch: {
    "form.postText": async function(text) {
      if (this.form.postText != "" && this.form.postText != null) {
        text.split(" ").forEach(item => {
          if (item.startsWith("@")) {
            this.mentionEnable = true;

            this.searchTerm = item.replace("@", "");
            if (this.searchTerm != "" && this.searchTerm != null) {
              setTimeout(() => {
                axios
                  .post("socialhub/searchmention", {
                    searchTerm: this.searchTerm
                  })
                  .then(res => {
                    this.mentionableUser = res.data.data.items;
                  });
              }, 1000);
            }
          } else {
            this.mentionEnable = false;
            this.searchTerm = "";
          }
        });
      }
    }
  },
  // async toggleLike() {
  //   var dammyLike = !postForm.isLiked;
  //   var res = await this.$store.dispatch('socialHubToggleLike', { id: this.postForm.id, isLiked: dammyLike });
  //   if (!res.data.alert.hasError) {
  //     this.postForm.isLiked = dammyLike;
  //   }
  // },
  async created() {
    this.loading = "updateScreenLoading";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      if (this.id != undefined && this.id != null) {
        await this.$store.dispatch("getLiveSessions");
        var res = await this.$store.dispatch("socialHubGet", this.id);
        if (res.data.alert.hasError) {
          this.$emit("closeMe");
        } else {
          this.form = res.data.data.item;
          this.form.postText = this.parseUrl(this.form.postText, this.form);
        }
      }
      this.loading = false;
    }, 500);
  }
};
</script>

<style lang="less">
#create-post-dialog {
  .modal-body {
    max-height: calc(~"100vh - 253px");
  }

  .post-type-select {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 1rem;
    .item {
      position: relative;
      transition: all 0.3s ease-in-out;
      &.active {
        transition: all 0.3s ease-in-out;
        background-color: #03658c;
        color: white;
        .icon {
          background-color: white;
          transition: all 0.3s ease-in-out;
          i {
            color: #03658c;
            transition: all 0.3s ease-in-out;
          }
        }
        .item-content {
          .head {
            color: white;
          }
          .sub {
            color: white;
          }
        }
      }
      height: 75px;
      background: #f1f1f1;
      border-radius: 8px;
      display: flex;
      flex-direction: row;
      cursor: pointer;
      align-items: center;
      justify-content: flex-start;
      padding: 12px;
      gap: 1rem;

      .icon {
        width: 45px;
        height: 45px;
        min-width: 45px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: #03658c;
        border-radius: 12px;
        i {
          font-size: 16px;
          color: white;
        }
      }
      .item-content {
        .head {
          font-weight: bold;
          font-size: 15px;
          color: #292f3b;
        }
        .sub {
          line-height: 16px;
          font-size: 13px;
          color: #505763;
        }
      }
    }
  }

  .controller-item {
    font-weight: bold;
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    padding: 8px 16px;
    background-color: #f2f2f2;
    border-radius: 8px;
    height: 42px;
    align-items: center;
    justify-content: space-between;

    span {
      i {
        color: #03658c;
      }
    }

    &.isPassive {
      background-color: #fff2f2 !important;

      span {
        i {
          color: #ff6565;
        }
      }
    }
  }
}
.fa-spin {
  animation-name: spin;
  animation-duration: 1000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.create-post-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;

  .create-post-select-section {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
    padding-bottom: 12px;
    border-bottom: 1px solid #f1f3f6;
  }

  .create-post-poll-section,
  .create-post-survey-section {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    padding: 16px 0px;

    .section-wrapper {
      margin-top: 14px;
      width: 100%;
    }
  }
}

.send-post-section {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
  width: 100%;

  .write-post-container {
    width: 100%;
    display: flex;
    flex-direction: column;

    .write-post-textarea {
      width: 100%;
      position: relative;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .mention-area {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        position: absolute;
        width: calc(~"100% - 98px");
        top: -60px;
        padding: 6px 6px;
        background-color: white;
        border-radius: 8px;
        box-shadow: 0 0 14px rgba(0, 0, 0, 0.45);
        overflow: hidden;
        pointer-events: all;

        .mention-item {
          display: inline-flex;
          justify-content: flex-start;
          align-items: center;
          flex-direction: row;
          position: relative;
          cursor: grabbing;

          img {
            width: 38px;
            height: 38px;
            border-radius: 50%;
            border: 4px solid #f1f1f1;
            box-sizing: border-box;

            &.isRectangle {
              border-radius: 6px !important;
            }
          }

          span {
            margin: 0px 6px;
            font-weight: 600;
            font-size: 13px;
            color: #292f3b !important;
            white-space: nowrap;
          }
        }
      }

      .write-area {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        position: relative;

        .add-image-post {
          width: 38px;
          height: 38px;
          border-radius: 8px;
          background: #f1f1f1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          position: absolute;
          left: 8px;
          z-index: 1;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center center;

          i {
            font-size: 16px;
            color: #505763;
            margin: 0px;
            padding: 0px;
            box-sizing: border-box;
            min-width: inherit;
            margin-top: 2px;
          }
        }

        textarea {
          min-height: 60px !important;
          padding: 8px 108px 8px 54px;
          box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.27);
          border: none !important;
        }

        .post-send-button {
          position: absolute;
          right: 8px;

          .send-icon {
            margin-right: 6px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/socialhub/CreatePost.vue